<wa-dialog class="tc-dialog" [lightDismiss]="false" [open]="isOpen()" (wa-hide)="onHide($event)">
    <div class="tc-content">
        <div class="tc-header">
            <wa-icon class="info-icon" name="square-info" />
            <h5>Before you continue</h5>
        </div>

        <p class="tc-body">
            To continue using CollectivIQ, please review and accept our Terms and Conditions and Privacy Policy. Your agreement is required
            to access your account and all platform features.
        </p>

        <label class="tc-agree">
            <input class="tc-native-checkbox" type="checkbox" [checked]="hasAgreed()" (change)="hasAgreed.set(!hasAgreed())" />
            <span
                >I have read and agree to the
                <a href="https://www.collectiviq.ai/terms-conditions/" rel="noopener noreferrer" target="_blank">Terms and Conditions</a>
                and
                <a href="https://www.collectiviq.ai/privacy-policy/" rel="noopener noreferrer" target="_blank">Privacy Policy</a>.</span
            >
        </label>

        <wa-button
            class="accept-btn"
            size="m"
            variant="brand"
            [disabled]="!hasAgreed() || isAccepting()"
            [loading]="isAccepting()"
            (click)="onAccept()"
            >Accept and continue</wa-button
        >
        <button class="logout-link" type="button" (click)="onDecline()">Log out</button>
    </div>
</wa-dialog>
